import { useEffect, useState } from 'react';
import { STORAGE } from "../storage";
import { initSoketiMaintenanceInterval, stopSoketiMaintenanceInterval, isSoketiMaintenanceIntervalRunning } from "../soketi/soketiMaintenanceInterval";
import { isSoketiConnected } from "../soketi/soketi";

const useSoketiMaintenanceInterval = () => {
    const [isSoketiActive, setIsSoketiActive] = useState(false);

    // Check if Soketi is active on mount
    useEffect(() => {
        const checkSoketiStatus = async () => {
            const soketiUrl = await STORAGE.get("soketiUrl");
            setIsSoketiActive(!!soketiUrl);
        };
        checkSoketiStatus();
    }, []);

    // Manage the Soketi maintenance interval lifecycle
    useEffect(() => {
        if (!isSoketiActive) {
            // If Soketi is not active, make sure the interval is stopped
            if (isSoketiMaintenanceIntervalRunning()) {
                stopSoketiMaintenanceInterval();
            }
            return;
        }

        // If Soketi is active, start the interval if not already running
        if (isSoketiConnected() && !isSoketiMaintenanceIntervalRunning()) {
            initSoketiMaintenanceInterval();
        }

        // Cleanup function to stop the interval when component unmounts
        return () => {
            if (isSoketiMaintenanceIntervalRunning()) {
                stopSoketiMaintenanceInterval();
            }
        };
    }, [isSoketiActive]);

    return null;
};

export default useSoketiMaintenanceInterval;
